import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { Grid, TextField, Typography } from '@mui/material';

import { Else, If, Then } from '../If';

export const Description = () => {
    const {
        pageState: { formData },
        pageActions
    } = usePageStore();

    function onChange(event: React.ChangeEvent<HTMLInputElement>) {
        pageActions.formData.updateFormItem({ description: event.target.value });
    }

    return (
        <Grid item xs={12}>
            <If condition={!!formData.readOnly}>
                <Then>
                    <Typography variant="subtitle1">{formData.description ? (formData.description as string) : i18n('no_description')}</Typography>
                </Then>
                <Else>
                    <TextField fullWidth label={i18n('description')} variant="outlined" onChange={onChange} value={formData.description ?? ''} />
                </Else>
            </If>
        </Grid>
    );
};
